module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shows && _vm.shows.length > 0) ? _c('div', {
    staticClass: "container-fluid section-show"
  }, [_c('div', {
    staticClass: "columns show-wrapper-outer is-gapless is-flex-mobile is-multiline",
    class: [{
      'is-centered': (_vm.shows && _vm.shows.length == 1)
    }]
  }, _vm._l((_vm.shows), function(show, index) {
    return _c('div', {
      staticClass: "column show-wrapper has-text-centered",
      class: {
        'is-6': _vm.split === 2,
        'is-4': _vm.split === 3,
        'is-half-mobile': _vm.type === 'previous',
        'is-half-mobile': _vm.type === 'upcoming'
      },
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true",
        "data-aos-delay": ((index % (_vm.isDesktop ? _vm.split : 2)) * 300)
      }
    }, [(!show.isMore) ? _c('div', {
      staticClass: "show-content"
    }, [_c('div', {
      staticClass: "focus-image-wrapper show-image-wrapper"
    }, [_c('a', {
      staticStyle: {
        "cursor": "auto"
      },
      attrs: {
        "href": ''
      },
      on: {
        "click": function($event) {
          return $event.preventDefault()
        }
      }
    }, [_c('img', {
      staticClass: "image square img-responsive",
      style: ([{
        'background-image': 'url(' + show.image.path + ')'
      }])
    }), _vm._v(" "), _c('div', {
      staticClass: "show-text-overlay"
    }, [_c('div', {
      staticClass: "show-text-wrapper"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(show.title))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(show.subtitle))]), _c('br')])])])])]) : _c('div', {
      staticClass: "show-content"
    }, [_c('div', {
      staticClass: "focus-image-wrapper show-image-wrapper"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:info@clientmanagementprobation.com?subject=Message from CMS',
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "image square img-responsive",
      style: ([{
        'background-image': 'url(' + show.image.path + ')'
      }])
    }), _vm._v(" "), _vm._m(0, true)])])])])
  }), 0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-text-overlay visible"
  }, [_c('div', {
    staticClass: "show-text-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Looking For Representation?")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("EMAIL US")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50fb24a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowSection.vue
// module id = 976
// module chunks = 1